(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scrollBars = [];
    var ticking = false;

    // Hoist the fixed bar to <body> so ancestor transforms/overflow don't trap it.
    function hoist() {
      var bars = document.querySelectorAll('[data-gp-sticky]:not([data-gp-hoisted])');
      for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        bar.setAttribute('data-gp-hoisted', '1');
        document.body.appendChild(bar);
        if (bar.getAttribute('data-gp-reveal') === 'scroll' && scrollBars.indexOf(bar) === -1) {
          scrollBars.push(bar);
        }
      }
      check();
    }
    function removeHoisted(id) {
      var sel = id
        ? '[data-gp-sticky="' + id + '"][data-gp-hoisted]'
        : '[data-gp-sticky][data-gp-hoisted]';
      var els = document.querySelectorAll(sel);
      for (var i = 0; i < els.length; i++) {
        var idx = scrollBars.indexOf(els[i]);
        if (idx !== -1) scrollBars.splice(idx, 1);
        els[i].parentNode.removeChild(els[i]);
      }
    }
    function check() {
      ticking = false;
      if (!scrollBars.length) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var vh = window.innerHeight || 1;
      for (var i = 0; i < scrollBars.length; i++) {
        var bar = scrollBars[i];
        if (bar.getAttribute('data-gp-dismissed') === '1') continue;
        var mult = parseFloat(bar.getAttribute('data-gp-reveal-vh')) || 1;
        if (y >= vh * mult) {
          bar.classList.add('gp-sticky--visible');
        } else {
          bar.classList.remove('gp-sticky--visible');
        }
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hoist);
    } else {
      hoist();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', function (e) {
      removeHoisted(e && e.detail ? e.detail.sectionId : null);
      hoist();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      removeHoisted(e && e.detail ? e.detail.sectionId : null);
    });
    document.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('[data-gp-sticky-close]');
      if (!closeBtn) return;
      var bar = closeBtn.closest('[data-gp-sticky]');
      if (bar) {
        bar.setAttribute('data-gp-dismissed', '1');
        bar.classList.add('gp-sticky--dismissed');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ldn-how-to-start"] && !Shopify.designMode) return;
  try {
    
  /**
   * Step walk-through: highlights each step in turn, drawing a dotted connector between
   * them, then loops. Mirrors the approved mock's cadence (step hold / line draw / pause),
   * with every interval exposed as a section setting.
   *
   * Runs per section instance and is re-init safe, so it survives theme-editor re-renders.
   * Skipped entirely when the visitor prefers reduced motion, or when the section is
   * offscreen (an IntersectionObserver pauses the loop to avoid pointless timers).
   */
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initSteps(list) {
      if (!list || list.dataset.ldnBound === 'true') return;
      list.dataset.ldnBound = 'true';

      var steps = Array.prototype.slice.call(list.querySelectorAll('[data-ldn-step]'));
      if (steps.length === 0) return;

      var hold = parseInt(list.dataset.stepHold, 10) || 2100;
      var lineDur = parseInt(list.dataset.lineDuration, 10) || 1200;
      var pause = parseInt(list.dataset.loopPause, 10) || 3000;
      var wantPop = list.dataset.pop === 'true';

      // Drive the CSS transition duration from the same setting as the JS schedule.
      list.style.setProperty('--ls-line-dur', lineDur + 'ms');

      var timers = [];
      var running = false;

      function clearTimers() {
        timers.forEach(window.clearTimeout);
        timers = [];
      }

      function reset() {
        steps.forEach(function (step) {
          step.classList.remove('is-active', 'is-linked', 'is-popped');
        });
      }

      function runCycle() {
        reset();
        var t = 0;
        steps.forEach(function (step, i) {
          timers.push(
            window.setTimeout(function () {
              steps.forEach(function (s) {
                s.classList.remove('is-active');
              });
              step.classList.add('is-active');
              // Last step gets the emphasis pop.
              if (wantPop && i === steps.length - 1) step.classList.add('is-popped');
            }, t)
          );
          // Draw the connector into the NEXT step during the hold, before it activates.
          if (i < steps.length - 1) {
            timers.push(
              window.setTimeout(function () {
                steps[i + 1].classList.add('is-linked');
              }, t + hold)
            );
            t += hold + lineDur;
          }
        });
        // Hold the finished state, then loop.
        timers.push(
          window.setTimeout(function () {
            if (running) runCycle();
          }, t + pause)
        );
      }

      function start() {
        if (running || reduceMotion.matches) return;
        running = true;
        runCycle();
      }

      function stop() {
        running = false;
        clearTimers();
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) start();
              else stop();
            });
          },
          { threshold: 0.25 }
        );
        io.observe(list);
      } else {
        start();
      }

      // If the visitor flips reduced-motion mid-session, respect it immediately.
      var onPrefChange = function () {
        if (reduceMotion.matches) {
          stop();
          reset();
        }
      };
      if (typeof reduceMotion.addEventListener === 'function') {
        reduceMotion.addEventListener('change', onPrefChange);
      }
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-ldn-steps]').forEach(initSteps);
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
    initAll(document);

    // Theme editor: re-init when this section is re-rendered.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-ldn-steps]').forEach(function (list) {
        list.dataset.ldnBound = 'false';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
